/**
 * Created by razial on 23.07.2025.
 */

const Merge3UnitTradeTutorial = function () {
    return new TutorialScenario(Merge3UnitTradeTutorial.NAME, {
        listSteps: Merge3UnitTradeTutorial.listSteps,
        isAvailable: function () {
            return !cleverapps.forces.isShown(Forces.TRADE_WINDOW_FORCE) && cleverapps.user.checkAvailable(cleverapps.config.availables.TRADE);
        }
    });
};

Merge3UnitTradeTutorial.NAME = "unit_trade_tutorial";

Merge3UnitTradeTutorial.listSteps = function () {
    const steps = [{
        onCheckConditions: function () {
            return true;
        },

        onStart: function () {
            this.force = cleverapps.forces.create(undefined, Forces.TRADE_WINDOW_FORCE);

            cleverapps.tutorial.on("trade_window_opened", () => this.finish(), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }, {
        onStart: function () {
            const unitTradeWindow = cleverapps.focusManager.currentWindow();
            const sourcePicker = unitTradeWindow.getSourcePicker();
            const sourcePickerIcon = sourcePicker.unitViews[0];

            this.force = cleverapps.forces.create(sourcePickerIcon, Forces.TRADE_SELECT_SOURCE, {
                pointer: true,
                highlights: [sourcePicker.picker]
            });

            cleverapps.tutorial.on("unit_trade_pick", (type) => {
                if (type === UnitTrade.SOURCE) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }, {
        onStart: function () {
            const unitTradeWindow = cleverapps.focusManager.currentWindow();
            const targetPicker = unitTradeWindow.getTargetPicker();
            const targetPickerIcon = targetPicker.unitViews[0];

            this.force = cleverapps.forces.create(targetPickerIcon, Forces.TRADE_SELECT_TARGET, {
                pointer: true,
                highlights: [targetPicker.picker]
            });

            cleverapps.tutorial.on("unit_trade_pick", (type) => {
                if (type === UnitTrade.TARGET) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }, {
        onStart: function () {
            const unitTradeWindow = cleverapps.focusManager.currentWindow();
            const sourcePicker = unitTradeWindow.getSourcePicker();
            const targetPicker = unitTradeWindow.getTargetPicker();
            const exchangeButton = unitTradeWindow.getExchangeButton();

            cleverapps.focusManager.setEventNodes([unitTradeWindow]);

            const dialogue = new MinimalDialogue({
                text: Messages.get("Forces.TradeExchange"),
                position: MinimalDialogue.POSITIONS.CENTER,
                rects: [sourcePicker.description.getSceneBoundingBox(), targetPicker.description.getSceneBoundingBox(), exchangeButton.getSceneBoundingBox()]
            });
            unitTradeWindow.addChild(dialogue);
            dialogue.display();
            dialogue.runAction(new cc.Sequence(
                new cc.DelayTime(5),
                new cc.CallFunc(() => {
                    dialogue.remove();
                })           
            ));

            this.finish();
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    }];

    return steps.map((step) => new TutorialStep(step));
};
